import React, { Component } from 'react';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import LoadingButton from '../buttons/LoadingButton';

class CreateApiKeyModal extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.handleApiKeyTypeInput = this.handleApiKeyTypeInput.bind(this);
    }

    getInitialState() {
        return {
            selectedApiKeyType: null,
            working: false
        };
    }

    handleApiKeyTypeInput(event) {
        this.setState({ selectedApiKeyType: Number.parseInt(event.target.value, 10) });
    }

    render() {
        const apiKeyTypes = this.props.model || [];
        const selectedApiKeyType = this.state.selectedApiKeyType;

        return (
            <div>
                <Modal.Header>
                    <h4>{this.props.title}</h4>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Row>
                            <Col lg={12}>
                                <div className="linebreaks">
                                    {this.props.message}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                {
                                    apiKeyTypes.map((item) => (
                                        <div key={item.condensedName} className="form-group">
                                            <input
                                                type="radio"
                                                name="selectedApiKeyType"
                                                id={item.condensedName}
                                                value={item.id}
                                                checked={item.id === selectedApiKeyType}
                                                onChange={this.handleApiKeyTypeInput}
                                            /> {item.displayName}
                                        </div>
                                    ))
                                }
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle="default" variant="warning" onClick={() => this.props.closeModal()}>Cancel</Button>
                    <LoadingButton bsStyle="success" variant="primary" loading={this.state.working} disabled={selectedApiKeyType === null} onClick={() => {
                        this.setState({ working: true });
                        this.props.saveModel(selectedApiKeyType);
                    }}>Add</LoadingButton>
                </Modal.Footer>
            </div>
        );
    }
}

export default CreateApiKeyModal;
